module.exports = __webpack_public_path__ + "img/i1.18a13952.png";